import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "@yfp/lib/utils";

type ButtonVariant = "primary" | "secondary" | "ghost";
type ButtonSize = "sm" | "md" | "lg";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

const variantStyles: Record<ButtonVariant, string> = {
  primary:
    "bg-brand-primary-regular text-white hover:bg-brand-primary-light disabled:cursor-not-allowed disabled:opacity-40",
  secondary:
    "border border-white/10 bg-white/5 text-white/70 hover:bg-white/10",
  ghost: "text-white/70 hover:bg-white/10",
};

const sizeStyles: Record<ButtonSize, string> = {
  sm: "h-9 px-3 text-13",
  md: "h-12 px-6 text-sm",
  lg: "h-14 px-8 text-sm",
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { variant = "primary", size = "md", className, children, ...props },
    ref,
  ) => (
    <button
      ref={ref}
      className={cn(
        "font-dm-sans inline-flex items-center justify-center gap-2 rounded-xl font-medium transition-all",
        variantStyles[variant],
        sizeStyles[size],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  ),
);

Button.displayName = "Button";
